<template>
  <div class="mainsa">
    <div class="top">
      <h3>物流管理</h3>
    </div>
    <div class="container">
      <div class="item_pro">
        <div class="item">
          <img src="@/assets/images/ck.png" alt="" srcset="" />
          <span>入库扫描</span>
        </div>

        <div class="item">
          <img src="@/assets/images/rk.png" alt="" srcset="" />
          <span>出货扫描</span>
        </div>

        <div class="item">
          <img src="@/assets/images/th.png" alt="" srcset="" />
          <span>退货扫描</span>
        </div>
      </div>
      <div class="item_pro">
        <div class="item">
          <img src="@/assets/images/lb.png" alt="" srcset="" />
          <span>入库明细</span>
        </div>

        <div class="item">
          <img src="@/assets/images/lb.png" alt="" srcset="" />
          <span>出货明细</span>
        </div>

        <div class="item">
          <img src="@/assets/images/lb.png" alt="" srcset="" />
          <span>退货明细</span>
        </div>
      </div>

      <div class="item_pro">

        <div class="item">
          <img src="@/assets/images/kh.png" alt="" srcset="" />
          <span>经销商</span>
        </div>

        <div class="item">
          <img src="@/assets/images/cp.png" alt="" srcset="" />
          <span>产品明细</span>
        </div>

        <div class="item" @click="tuichu">
          <img src="@/assets/images/tc.png" alt="" srcset="" />
          <span>退出登录</span>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    tuichu() {
      sessionStorage.removeItem("JigGyrBuasd");
      this.$router.push("/login");
    },
  }
};
</script>

<style scoped>
body {
  padding: 0;
  margin: 0;
}

.mainsa {
  width: 100vw;
  height: 100vh;
}

.top {
  width: 100%;
  height: 100%;
  background: #2bae85;
}

.top>h3 {
  width: 100%;
  text-align: center;
  color: white;
  font-size: 24px;
  line-height: 90px;
}

.container {
  width: 90%;
  margin-left: 5%;
  background: white;
  box-shadow: 0 0 5px 1px #aaa;
  border-radius: 8px;
  overflow: hidden;
  position: absolute;
  top: 90px;
  padding: 15px;
  box-sizing: border-box;
}

.container>.item_pro {
  display: flex;
  flex-direction: row;
}

.container>.item_pro>.item {
  width: 100px;
  height: 100px;
  border: #aaa dashed 1px;
  border-radius: 6px;
  margin: 8px;
}

.container>.item_pro>.item>img {
  width: 30%;
  margin: 35%;
  margin-bottom: 0;
  margin-top: 25%;
}

.container>.item_pro>.item>span {
  width: 100%;
  display: block;
  text-align: center;
  color: #999;
}
</style>
